/**
 * @module businessComponents\mdl\siteComponent
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch, Model } from "vue-property-decorator";
import StructBase from "./structBase";
// import AreaComponent from "./areaComponent/areaComponent";

@Component
export default class SiteComponent extends StructBase {
  private args = { level: "工厂" };

  @Watch("level")
  private observeLevel() {
    if (this.level) {
      this.args.level = this.level;
    }
  }

  private change(selected) {
    this.$emit("changed", selected);
    this.$emit("input", selected);
  }
}
